export default {
    protocol: 'https',
    host: 'manhole.biz',
    port: 80,
};
